<template>
  <div class="breadcrumb"> 
    <ul>
      <!-- <li v-for="(item, index) in items" :key="index" :class="{'last-child': lastChild}"> -->
      <li v-for="(item, index) in getComputedStatus" :key="index">
        <span :class="[item.status ? 'active' : '']">{{ item.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'adx-breadcrumb-status',
  components: {

  },
  props: {
    isActive: {
      type: String,
      required: false
    },
    items:{
      type: Array,
      required: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    getComputedStatus: function () {
      let res = []
      let selected = null
      let progress = this.isActive? this.isActive.toUpperCase():''

      for (var i=0; i<this.items.length;  i++){
        if (this.items[i].title.toUpperCase() === progress) selected = i
      }
      for (var i=0; i<this.items.length; i++){
        let status = false
        if (selected != null && selected >=i){
          status =true
        }
        res.push({
          status: status,
          title: this.items[i].title
        })
      }
      return res
    }
  },
  watch: {
    // isActive:function(){
    //   this.$nextTick(function () {
    //     this.reset()
    //   })
    //   this.$nextTick(function () {
    //     this.status()
    //   })
      
      
    // }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    // this.status()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    status(){
      // console.log('STATUS', this.isActive)
      let selected = null
      let progress = this.isActive? this.isActive.toUpperCase():''
      for (var i=0; i<this.items.length;  i++){
        if (this.items[i].title.toUpperCase() === progress) selected = i
      }
      for (var i=selected; i>=0;  i--){
        if (this.items[i]){
          this.items[i].status = true
        }
      }
    },
    reset(){
      for (var i = 0; i < this.items.length; i++){
        this.items[i].status = false
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>